import React from "react";
import { radioButtonStyle, labelStyle } from "./radio-button.css";
import { Text } from "@vagastec/ensemble-core";

export function RadioButton({ label = "", disabled = false, ...rest }) {
  return (
    <label className={labelStyle} data-disabled={disabled}>
      <input
        type="radio"
        disabled={disabled}
        {...rest}
        className={radioButtonStyle}
      />
      <Text>{label}</Text>
    </label>
  );
}
